<template>
  <div class="chat-input">
    <el-input v-model="localMessage" placeholder="请输入内容" @keyup.enter.native="sendMessage">
      <template slot="append">
        <el-button type="primary" @click="sendMessage" class="btn-send">发送</el-button>
      </template>
    </el-input>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      localMessage: this.value
    };
  },
  watch: {
    value(newValue) {
      this.localMessage = newValue;
    },
    localMessage(newValue) {
      this.$emit('input', newValue);
    }
  },
  methods: {
    sendMessage() {
      const message = this.localMessage.trim();
      if (!message) return; // 检查消息是否为空或仅包含空白字符

      // 正则表达式用于检测简单的文本颜文字，例如：(*╹▽╹*) 
      // 这里只是一个示例，实际应用中可能需要根据具体情况调整
      const textEmojiRegex = /[$$\*\+\-\=\{\}$$\/\\]/;

      if (textEmojiRegex.test(message)) {
        // console.warn("消息中包含了不允许的文本颜文字");
        // 可以选择提示用户或者直接返回不发送消息
        this.$message.warning("暂不支持特定符号如括号、星号等组成的颜文字");
        return;
      }

      // 如果还想进一步过滤掉标准的Unicode表情符号，可以添加如下代码
      const emojiRegex = /[\uD83C-\uDBFF\uDC00-\uDFFF]+/;
      if (emojiRegex.test(message)) {
        // console.warn("消息中包含了不允许的表情符号");
        this.$message.warning("暂不支持表情符号");
        return;
      }

      // 如果验证通过，则发送消息
      this.$emit('send-message', message);
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-input {
  position: absolute;
  bottom: 0;
  width: calc(100% - 250px);
  box-sizing: border-box;
  padding: 10px;
  background-color: #f5f7fa;
}

.btn-send {
  background-color: #0066cc !important;
  color: #ffffff !important;
  border-radius: 0 4px 4px 0;

  &:active {
    background-color: #89bbee !important;
  }
}
</style>